<template>
  <div>
    <div class="card" style="padding:5px 10px 5px; border-radius: 10px;">
        <div class="card-header">
            <div class="row">
                <div class="col-md-10">
                    <strong style="font-size:20px">Información de la nomina</strong><br>
                    <span style="color:darkgray">Listado de todas las personas que tienen salario fijo</span><br>
                    <span style="color:darkgray">Resumen de los gatos de nomina: <span style="color:green;">{{ resumenNomina }}</span> </span>
                </div>
                <!-- <div class="col-md-2">
                    <button class="btn pull-right" style="border-radius: 8px;" @click="abrirModal()">
                        <i class="fa fa-arrow-right"></i>
                    </button>
                </div> -->
            </div>
        </div>
        <hr>
        <div class="card-content" style="max-height: 400px; overflow: scroll; overflow-x: hidden;">
            <div class="row">
                <div class="col-md-12" v-for="persona in informacionNomina" :key="persona.nombre">
                    <div class="card" style="border:1px darkgray solid;">
                        <div class="card-content">
                            <div class="row">
                                <div class="col-md-3">
                                    <strong>{{ persona.nombre }}</strong> <br>
                                    <small style="color:grey;">NOMBRE COMPLETO</small>
                                </div>
                                <div class="col-md-3">
                                    <!-- <i class="fa fa-arrow-up" style="color:green;"></i> -->
                                    <strong style="color:green"> {{ persona.salarioFijo }}</strong> <br>
                                    <small style="color:grey;">SALARIO FIJO</small> <br>
                                    
                                </div>
                                <div class="col-md-3">
                                    <!-- <i class="fa fa-arrow-up" style="color:green;"></i> -->
                                    <strong> {{ persona.prestaciones }}</strong> <br>
                                    <small style="color:grey;">PRESTACIONES SOCIALES</small>
                                </div>
                                <div class="col-md-3">
                                    <!-- <i class="fa fa-arrow-down" style="color:red;"></i> -->
                                    <strong> {{ persona.transporte }}</strong> <br>
                                    <small style="color:grey;">AUXILIO DE TRANSPORTE</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import nomicard from "src/components/aDashboard/nomina/cardnomina.vue"
import axiosInstance from "src/global-services/axiosInstance";
import formatearPesosColombianos from "../../../global-services/formatear-pesos";
export default {
    data(){
        return {
            informacionNomina: [],
            resumenNomina: 0
        }
    },
    methods: {
        getNomina: async function(){
            try{
                this.$modal.show('carga');
                const BASE_URL = "api/nomina-dashboard";
                const response = await axiosInstance.get(BASE_URL);
                if(response.data.status === true){
                    const data = response.data.data;
                    let resumen = 0;
                    let dataFormated = data.map(element => {
                        const prestaciones = element.eps + element.pension + element.arl;
                        const transporte = element.transporte;
                        resumen = resumen + ((element.salarioFijo - prestaciones) + transporte); 
                        return {
                            nombre : element.nombre,
                            salarioFijo: formatearPesosColombianos(element.salarioFijo - prestaciones),
                            prestaciones: formatearPesosColombianos(prestaciones),
                            transporte: formatearPesosColombianos(transporte),
                        }
                    });
                    this.resumenNomina = formatearPesosColombianos(resumen);
                    this.informacionNomina = dataFormated;
                }
            }catch(error){
                console.log(error);
            }finally{
                this.$modal.hide('carga');
            }
        }
    },
    components: {
        nomicard
    },
    mounted(){
        // this.getNomina()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/informacionGastoNomina.vue